import { render, staticRenderFns } from "./STooltip.vue?vue&type=template&id=951739aa&scoped=true"
import script from "./STooltip.vue?vue&type=script&lang=js"
export * from "./STooltip.vue?vue&type=script&lang=js"
import style0 from "./STooltip.vue?vue&type=style&index=0&id=951739aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951739aa",
  null
  
)

export default component.exports